import styled from '@emotion/styled';
import { css } from 'emotion';
import { SM_SCREEN_MAX } from '../../modules/Styleguide';

export const Header2 = styled.h2`
  color: #fff;
  margin: 0 auto;
  margin-bottom: 42px;
  font-size: 3.6rem;
  font-weight: bold;
  @media (max-width: ${SM_SCREEN_MAX}px) {
    display: none;
  }
`;

export const SwitchToAnchorOverrideCSS = css`
  padding: 56px 0 170px 0 !important;
  @media (max-width: ${SM_SCREEN_MAX}px) {
    padding: 24px 0 120px 0 !important;
  }
`;
